import { ResponseError } from '@backstage/errors';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const initRequestOption = {
  headers: { Accept: `application/json` }
};
class EndOfLifeClient {
  constructor(options) {
    __publicField(this, "baseUrl");
    __publicField(this, "discoveryApi");
    __publicField(this, "fetchApi");
    __publicField(this, "identityApi");
    this.baseUrl = options.baseUrl;
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.identityApi = options.identityApi;
  }
  async getProducts() {
    const res = await fetch(`${this.baseUrl}/api/all.json`, initRequestOption);
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return await res.json();
  }
  async getProduct(product) {
    const res = await fetch(
      `${this.baseUrl}/api/${product.toLowerCase()}.json`,
      initRequestOption
    );
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    const result = await res.json();
    return result.map((item) => ({
      ...item,
      product
    }));
  }
  async getCycle(product, cycle) {
    const res = await fetch(
      `${this.baseUrl}/api/${product.toLowerCase()}/${cycle.toLowerCase()}.json`,
      initRequestOption
    );
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    const result = await res.json();
    return {
      ...result,
      product,
      cycle
    };
  }
  getProductLink(product) {
    return `${this.baseUrl}/${product.toLowerCase()}`;
  }
  getLink() {
    return this.baseUrl;
  }
  async getAnnotationProducts(annotationProducts) {
    return await Promise.all(
      annotationProducts.map((annotationProduct) => {
        if (annotationProduct.product && annotationProduct.cycle) {
          return this.getCycle(
            annotationProduct.product,
            annotationProduct.cycle
          );
        }
        return this.getProduct(annotationProduct.product);
      })
    ).then((response) => response.flat());
  }
  async getFromURL(url) {
    const res = await fetch(url, initRequestOption);
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return await res.json();
  }
  async getFromSource(fileUrl) {
    const baseUrl = await this.discoveryApi.getBaseUrl("endoflife");
    const { token } = await this.identityApi.getCredentials();
    const targetUrl = `${baseUrl}/file?url=${encodeURIComponent(fileUrl)}`;
    const res = await this.fetchApi.fetch(targetUrl, {
      headers: token ? {
        Authorization: `Bearer ${token}`
      } : void 0
    });
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return await res.json();
  }
}

export { EndOfLifeClient };
//# sourceMappingURL=EndOfLifeClient.esm.js.map
